/* eslint-disable import/no-named-as-default-member */
import { call, put } from 'redux-saga/effects'

// import OrderActions from '../reducers/hasuraOrderReducer'
import delivererOrderActions from '../reducers/delivererOrderReducer'
import firebase from '../config/firebase'

export function* getDelivererOrders({ delivererKeys, startFrom, endAt }) {
  const response = {}
  try {
    const delivererKeyLength = delivererKeys.length

    for (let index = 0; index < delivererKeyLength; index += 1) {
      const delivererKey = delivererKeys[index]

      const delivererOrderRef = firebase
        .database()
        .ref(`deliverer_orders/${delivererKey}`)
        .orderByChild('created_at')
        .startAt(startFrom)
        .endAt(endAt)

      const snapshot = yield call([delivererOrderRef, delivererOrderRef.once], 'value')
      response[delivererKey] = snapshot.val()
    }

    yield put(delivererOrderActions.setDelivererOrders(response))
  } catch (err) {
    yield put(delivererOrderActions.setDelivererOrders(err))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/delivererOrdersSaga.js